<template>
  <div class="home">
    <div class="d-grid gap-2 col-6 mx-auto menu">
      <button type="button" class="btn btn-success w-100" @click="router.push({name: 'register'})">註冊用戶</button>
      <button type="button" class="btn btn-danger w-100" @click="router.push({name: 'reset'})">重設密碼</button>
      <button type="button" class="btn btn-secondary w-100" @click="router.push({name: 'list'})">用戶列表</button>
    </div>
  </div>
</template>
<script setup>
import {useRouter} from 'vue-router';

const router = useRouter();
</script>
<style scoped>
.btn{
  margin: 10px 0;
}
.btn{
  box-shadow: 0 4px 5px rgba(0, 0, 0, 0.2);
}
@media screen and (max-width:900px) {
  .btn{
    font-size: 12px;
    min-width: 100px;
  }
}
</style>
